import React, { useEffect, useMemo, useState } from 'react';
import { Button, Modal, Row, Col, Spinner } from "react-bootstrap";
import TabellaLista from '../../../components/Tabella/TabellaLista';
import { ChipFilter } from '../../../components/Tabella/ChipFilter';
import MyApiClient from '../../../../api-client/MyApiClient';
import { conMotivo } from "../../../components/Util/erroreServer";
import { useNavigate } from 'react-router-dom';

// Valori dei filtri a chip, come compaiono nella lista.
const STATO_OPTIONS = ['Bozza', 'Attivo', 'Non attivo'];

/*
 * Corsi — elenco squadre: copia dell'Elenco squadre, con i dati veri. Senza il tasto
 * «Aggiungi Squadra»: in Corsi la squadra si crea dalla scheda del corso.
 */
export const CorsiSquadrePage = ({ bookingCourseId = null, headerButtons = null }) => {

	const navigate = useNavigate();

	const [data_json, setDataJson] = useState(null);
	const isFiltered = bookingCourseId !== null;
	// Chip a scelta multipla: all'inizio tutti accesi
	const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);

	const filteredData = useMemo(
		() => data_json && data_json.filter((row) => {
			// Uno stato fuori dai chip (es. "Sconosciuto") resta sempre visibile
			const stato = row.status_label?.label;
			return !STATO_OPTIONS.includes(stato) || statoFilter.includes(stato);
		}),
		[data_json, statoFilter],
	);

	const [modalShowed, setModalShowed] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalText, setModalText] = useState('');

	const [loadingShowed, setLoadingShowed] = useState(false);


	function openDetail(row) {
		if (row.status === 'DRAFT') {
			navigate(`/struttura/corsi/squadre/${row.id}`);
		} else {
			navigate(`/struttura/corsi/squadre/${row.id}`);
		}
	}




	
	const data_column = [
		{
			Header: 'Nome Squadra',
			Footer: 'Nome Squadra',
			accessor: 'name',
		},
		// Dentro la scheda di un corso il nome del corso sarebbe sempre lo stesso: la colonna serve solo nella lista generale
		...(isFiltered ? [] : [{
			Header: 'Corso',
			Footer: 'Corso',
			accessor: 'bookingCourseName',
		}]),
		{
			Header: 'Staff tecnico',
			Footer: 'Staff tecnico',
			accessor: 'coachName',
		},

		{
			Header: 'Impianto',
			Footer: 'Impianto',
			accessor: 'venueName',
		},
		{
			Header: 'Membri',
			Footer: 'Membri',
			accessor: 'members',
			disableGlobalFilter: true,
		},
		// Dentro la scheda del corso periodo e orari stanno nella scheda Pianificazione
		...(isFiltered ? [] : [{
			Header: 'Periodo',
			Footer: 'Periodo',
			accessor: 'period',
			disableGlobalFilter: true,
		},
		{
			Header: 'Orario Settimanale',
			Footer: 'Orario Settimanale',
			accessor: 'weeklySchedule',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return (
					<div style={{ whiteSpace: 'pre-line' }}>
						{value}
					</div>
				)
			}
		}]),
		{
			Header: 'Stato',
			Footer: 'Stato',
			accessor: 'status_label',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return (
					<div className="d-flex align-items-center">
						<i className={`fa fa-circle me-1 ${value ? value.class : ''}`}></i>
						{value ? value.label : ''}
					</div>
				)
			},
			disableFilters: true,
		},

	];
	
	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    let token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
				const [bookingCourseTeams] = await Promise.all([
                        apiClient.getBookingCourseTeams(token, bookingCourseId)
                    ]);
					setLoadingShowed(false);

					if(bookingCourseTeams) {
						let data = [];
						bookingCourseTeams.forEach(element => {
							const formatWeeklySchedule = (weeklySchedule) => {
								if (!weeklySchedule || weeklySchedule.length === 0) return 'Nessun orario';
								
								const dayNames = {
									'MONDAY': 'Lunedì',
									'TUESDAY': 'Martedì',
									'WEDNESDAY': 'Mercoledì',
									'THURSDAY': 'Giovedì',
									'FRIDAY': 'Venerdì',
									'SATURDAY': 'Sabato',
									'SUNDAY': 'Domenica'
								};
								
								return weeklySchedule.map(schedule => 
									`${dayNames[schedule.dayOfWeek] || schedule.dayOfWeek} ${schedule.startTime}-${schedule.endTime}`
								).join('\n');
							};
							
							const formatDate = (dateString) => {
								if (!dateString) return '-';
								const date = new Date(dateString);
								return date.toLocaleDateString('it-IT', {
									day: '2-digit',
									month: '2-digit',
									year: 'numeric'
								});
							};
							let row = {
								"id": element.id,
								"name": element.name || '-',
								"bookingCourseName": element.bookingCourseName || '-',
								"coachName": element.coachName || '-',
								"clubName": element.clubName || '-',
								"venueName": element.venueName || '-',
								"members": `${element.membersIds?.length || 0}/${element.maxMembers}` || '-',
								"period": `${formatDate(element.startDate)} - ${formatDate(element.endDate)}` || '-',
								"weeklySchedule": formatWeeklySchedule(element.weeklySchedule),
								"status": element.status || 'UNKNOWN',
								"status_label": element.status === 'ACTIVE'
									? { label: 'Attivo', class: 'text-success' }
									: element.status === 'INACTIVE'
									? { label: 'Non attivo', class: 'text-primary' }
									: element.status === 'DRAFT'
									? { label: 'Bozza', class: 'text-warning' }
									: { label: element.status || 'Sconosciuto', class: 'text-secondary' }
							};
							data.push(row);
						});
						setDataJson(data);
					} else {
						setModalTitle("Errore durante il caricamento");
						setModalText(conMotivo("Si è verificato un errore durante il caricamento dei team"));
						setModalShowed(true);
					}
                } else {
					setModalTitle("Errore di autenticazione");
					setModalText("Token di autenticazione non trovato");
					setModalShowed(true);
				}
            } catch (error) {
                console.error("Error fetching data:", error);
				setLoadingShowed(false);
				setModalTitle("Errore durante il caricamento");
				setModalText(conMotivo("Si è verificato un errore durante il caricamento dei team"));
				setModalShowed(true);
            }
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bookingCourseId]);

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

			<TabellaLista
				pageList={!isFiltered}
				cardTitle={'Squadre'}
				hasSearch={true}
				searchPlaceholder={isFiltered ? 'Cerca per squadra, staff tecnico o impianto' : 'Cerca per squadra, corso, staff tecnico o impianto'}
				hasFilter={false}
				filterControl={
					<div className="sid-chip-filters">
						<ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
					</div>
				}
				data_column={data_column}
				data_json={filteredData}
				openColumn={'name'}
				openRow={(row) => openDetail(row)}
				headerButtons={headerButtons}
				sort_by={'name'}
                sort_type={'asc'}
			/>
		</>
	)
}
export default CorsiSquadrePage;